import { useLayoutEffect } from 'react';

/** KU – optionally reset scroll whenever {@link enabled} changes, as long as it
 * is truthy */
export default function useResetScrollEffect(enabled: unknown) {
  useLayoutEffect(() => {
    if (enabled) {
      window.requestAnimationFrame(() => window.scroll(0, 0));
    }
  }, [enabled]);
}
